import { Box } from '@mui/system'
import { useCallback, useEffect, useState } from 'react'
import { EntryRegistration } from './useVirtualRender'
import React from 'react'
import { useCurrentRef } from '@app/hooks'
import anylogger from '@app/anylogger'

const log = anylogger('VisibilityPlaceholder')

interface VisibilityPlaceholderProps {
	defaultHeight: string
	registerRef: EntryRegistration
	debugStr?: string
}
export const VirtualRenderWrapper = React.forwardRef(function VirtualRenderWrapper(
	props: React.PropsWithChildren<VisibilityPlaceholderProps>,
	passedRef: any
) {
	const { registerRef, defaultHeight, debugStr, children } = props

	const [visible, setVisible] = useState(false)
	const [ref, setRef] = useCurrentRef<HTMLElement>(passedRef)

	const setVis = useCallback((vis: boolean) => {
		setVisible(vis)
	}, [])
	useEffect(() => {
		if (!ref) return
		registerRef(ref, { setVisible: setVis })
	}, [ref, registerRef, setVis])
	const defProp = visible ? {} : { height: defaultHeight, whiteSpace: 'pre' }

	const content = visible ? children : ' '
	// if (visible) log('Render content', debugStr)

	return (
		<Box ref={setRef} sx={{ ...defProp }}>
			{content}
		</Box>
	)
})
